// extracted by mini-css-extract-plugin
module.exports = {"comments":"Comments_comments__1Ubtf","comment":"Comments_comment__3KXmT","commentHighlight":"Comments_commentHighlight__7WA3i"};